import { render, staticRenderFns } from "./SetUpBindPhone.vue?vue&type=template&id=08531ca1&"
import script from "./SetUpBindPhone.vue?vue&type=script&lang=js&"
export * from "./SetUpBindPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports